import { Box, Container, Typography, Stack, Link } from "@mui/material";
import { COMPANY } from "../config/companyInfo";

export default function MaintenancePage({ title, message }) {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "primary.main",
                color: "common.white",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Container maxWidth="sm">
                <Stack spacing={3} alignItems="center" textAlign="center">
                    <Box
                        component="img"
                        src="/assets/logo/appLogo.png"
                        alt={COMPANY.brandName}
                        sx={{ height: 56 }}
                    />
                    <Typography variant="h4" sx={{ fontWeight: 800 }}>
                        {title}
                    </Typography>
                    <Typography variant="body1" sx={{ opacity: 0.85, lineHeight: 1.8 }}>
                        {message}
                    </Typography>
                    <Stack spacing={0.5} sx={{ opacity: 0.7, fontSize: 14 }}>
                        <Typography variant="body2">Podrška:</Typography>
                        <Link href={`mailto:${COMPANY.supportEmail}`} color="inherit">
                            {COMPANY.supportEmail}
                        </Link>
                        <Link href={`tel:${COMPANY.supportPhoneTel}`} color="inherit">
                            {COMPANY.supportPhone}
                        </Link>
                    </Stack>
                    {/* /brisanje-naloga ostaje dostupna (uslov prodavnica), samo se ne reklamira ovde. */}
                    <Stack direction="row" spacing={2} sx={{ opacity: 0.7, fontSize: 13, pt: 1 }}>
                        <Link href="/uslovi-kupovine" color="inherit">
                            Uslovi kupovine
                        </Link>
                        <Link href="/politika-privatnosti" color="inherit">
                            Politika privatnosti
                        </Link>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
